/** Matches the two shapes the date inputs emit and receive: "YYYY-MM-DD" and "YYYY-MM-DDTHH:mm". */
const LOCAL_VALUE = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?$/

/**
 * Read a form value as a local calendar date.
 *
 * `new Date('2026-10-15')` is parsed as UTC midnight, so every timezone west of
 * Greenwich renders it as the 14th — a date picker fed that value then labels and
 * highlights the day before the one the user clicked. Anything carrying an explicit
 * offset ("Z", "+02:00") is a real instant and still goes through `Date`.
 *
 * Returns undefined when the value is not a date at all.
 */
export const parseLocalValue = (value: string): Date | undefined => {
  const parts = LOCAL_VALUE.exec(value)
  const date = parts
    ? new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]), Number(parts[4] ?? 0), Number(parts[5] ?? 0))
    : new Date(value)
  return isNaN(date.getTime()) ? undefined : date
}
